import { BasicEvent } from "@h4x/common";
import type { Subscriber, Unsubscriber } from "svelte/store";

export class HewSyncType {
	protected constructor(x: void) {
		if ((x as any) !== Symbol.for("HewSyncType::Internal::Create")) {
			throw new Error("Cannot create");
		}
	}

	public readonly onUpdate = new BasicEvent<(item: this) => void>();
	public readonly onRemove = new BasicEvent<(item: this) => void>();
	public readonly onReplaced = new BasicEvent<(item: this, target: any) => void>();

	public readonly loading: boolean = true;
	public readonly error: Error | undefined = undefined;
	public readonly updating = false;
	public readonly removed = false;

	private loadingPromise: Promise<this> | undefined;
	private loadingPromiseResolve: ((value: this) => void) | undefined;

	protected setLoaded() {
		(this.loading as any) = false;
		if (this.loadingPromiseResolve !== undefined) {
			this.loadingPromiseResolve(this);
		}
	}

	protected setErrored(error: Error) {
		(this.error as any) = error;
		(this.loading as any) = false;
		if (this.loadingPromiseResolve !== undefined) {
			this.loadingPromiseResolve(this);
		}
		this.onUpdate.execute(this);
	}

	public load() {
		if (this.loading) {
			if (this.loadingPromise === undefined) {
				this.loadingPromise = new Promise((resolve) => {
					this.loadingPromiseResolve = resolve;
				});
			}
			return this.loadingPromise;
		}
		return Promise.resolve(this);
	}

	public setUpdating(value: boolean) {
		(this.updating as any) = value;
		this.onUpdate.execute(this);
	}

	public subscribe(run: Subscriber<this>): Unsubscriber {
		let ref = this.onUpdate.addCallback(() => {
			run(this);
		});
		let ref2 = this.onRemove.addCallback(() => {
			run(this);
		});
		run(this);
		return () => {
			ref.remove();
			ref2.remove();
		};
	}

	protected replace(item: this) {
		this.onReplaced.execute(this, item);
	}
}
